import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { sortBy, toArray } from 'lodash';

import { DiscountListComponent } from '../../discount/DiscountListComponent';

import './DiscountsListComponent.scss';

class DiscountsListComponent extends React.Component {
    render() {
        const { discounts, DETAIL_CASHBACK_TITLE } = this.props;
        return (
            <section className="fm-remises">
                {discounts.filter(d => d.onlineActive).length > 0 && (
                    <div>
                        <h3>{DETAIL_CASHBACK_TITLE}</h3>
                        <DiscountListComponent discounts={discounts} showArrow />
                    </div>
                )}
            </section>
        );
    }
}

DiscountsListComponent.propTypes = {
    partnerId: PropTypes.string.isRequired
};

const mapStoreToProps = (state, ownProps) => ({
    DETAIL_CASHBACK_TITLE: state.i18n.page.MERCHANTCARD.DETAIL_CASHBACK_TITLE,
    discounts: sortBy(toArray(state.discount.discounts[ownProps.partnerId]), ['order'])
});

export default connect(mapStoreToProps)(DiscountsListComponent);



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/DiscountsListComponent.js